import {
  Box,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Switch,
  Theme,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import React from "react";

import clsx from "clsx";

import { LoadedEventDefinition } from "../../../types/global";

const useStyles = makeStyles((theme: Theme) => ({
  showHidden: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    display: "flex",
    alignItems: "center",
  },
}));

type HiddenEventsFilterProps = {
  allEvents: LoadedEventDefinition[];
  showHidden: boolean;
  setShowHidden: React.Dispatch<React.SetStateAction<boolean>>;
};

function HiddenEventsFilter({
  allEvents,
  showHidden,
  setShowHidden,
}: HiddenEventsFilterProps) {
  const classes = useStyles();

  const hiddenEvents = allEvents.filter((e) => e.is_hidden);
  const numHiddenEventsText =
    hiddenEvents.length === 1
      ? "1 Hidden Event"
      : `${hiddenEvents.length} Hidden Events`;

  if (hiddenEvents.length <= 0) {
    return null;
  }

  return (
    <Tooltip
      title={`
                You have ${numHiddenEventsText.toLowerCase()} that won't be shown by default.
                You can toggle the visibility of these events by clicking the switch.
                To permanently unhide an event, click on the event to open the detailed
                Event Editor Drawer and click "Restore Event".
            `}
      PopperProps={{ style: { marginTop: -30 } }}
    >
      <Box className={clsx(classes.showHidden)}>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={showHidden}
                onChange={() => setShowHidden(!showHidden)}
              />
            }
            label={
              <FormLabel style={{ justifyContent: "center" }}>
                {numHiddenEventsText}
              </FormLabel>
            }
            labelPlacement="start"
          />
        </FormGroup>
      </Box>
    </Tooltip>
  );
}

export default HiddenEventsFilter;
